package com.essntl.features.tag.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun SelectedTagItem(
    tag: TagModel,
    onUnselect: () -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(.5f.spacing),
        modifier = Modifier
            .height(EsConstants.MediumButtonHeight)
            .clip(CircleShape)
            .background(MaterialTheme.esColorScheme.tinted)
            .padding(horizontal = 2.spacing)
    ) {
        Text(
            text = tag.name,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p1Regular16,
        )

        EsLargeIcon(
            res = EsIcons.Close,
            modifier = Modifier
                .clip(CircleShape)
                .clickable {
                    onUnselect()
                }
        )
    }
}